export default [
    {
      title: 'menu.SavedQuotes',
      icon: 'ArchiveIcon',
      tagVariant: 'light-danger',
      route:'savedquotes'
    },
  ]
  